


















































































interface curAccount {
	addtax: string;
	accountBookId: number;
	startPeriod: string;
	endPeriod: string;
}
interface tabs {
	text: string;
	tip: string;
	name: string;
	show: boolean;
}

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
import AnnualEITList, {
	IncomeTaxAnnualList
} from "../components/AnnualEITList/AnnualEITList";
import AnnualEITDialogVue from "../components/AnnualEITList/AnnualEITDialog.vue";
import SideNavVue from "../components/Declaration/SideNav.vue";
import AnnualEITA100000Vue from "./AnnualEITList/AnnualEITA100000.vue";
import AnnualEITA101010Vue from "./AnnualEITList/AnnualEITA101010.vue";
import AnnualEITA102010Vue from "./AnnualEITList/AnnualEITA102010.vue";
import AnnualEITA104000Vue from "./AnnualEITList/AnnualEITA104000.vue";
import AnnualEITA105000Vue from "./AnnualEITList/AnnualEITA105000.vue";
import AnnualEITA105050Vue from "./AnnualEITList/AnnualEITA105050.vue";
import AnnualEITA105060Vue from "./AnnualEITList/AnnualEITA105060.vue";
import AnnualEITA105080Vue from "./AnnualEITList/AnnualEITA105080.vue";
import AnnualEITA106000Vue from "./AnnualEITList/AnnualEITA106000.vue";
import AnnualEITA000000Vue from "./AnnualEITList/AnnualEITA000000.vue";
import AnnualEITA107040Vue from "./AnnualEITList/AnnualEITA107040.vue";
import AnnualEITBalanceVue from "../components/AnnualEITList/AnnualEITBalance.vue";
import { mapGetters } from "vuex";
@Component({
	...mapGetters(["accountBook"]),
	components: {
		"month-selector": MonthSelectorVue,
		"annualEIT-dialog": AnnualEITDialogVue,
		"side-nave": SideNavVue,
		AnnualEITA100000: AnnualEITA100000Vue,
		AnnualEITA101010: AnnualEITA101010Vue,
		AnnualEITA102010: AnnualEITA102010Vue,
		AnnualEITA104000: AnnualEITA104000Vue,
		AnnualEITA105000: AnnualEITA105000Vue,
		AnnualEITA105050: AnnualEITA105050Vue,
		AnnualEITA105060: AnnualEITA105060Vue,
		AnnualEITA105080: AnnualEITA105080Vue,
		AnnualEITA106000: AnnualEITA106000Vue,
		AnnualEITA000000: AnnualEITA000000Vue,
		AnnualEITA107040: AnnualEITA107040Vue,
		Balance: AnnualEITBalanceVue
	}
})
export default class AnnualEIT extends Vue {
	curAccount: curAccount = {
		addtax: this.$store.state.accountBook.addtax,
		accountBookId: this.$store.state.accountBook.id,
		startPeriod: "",
		endPeriod: ""
	};
	activeTab: string = "";
	tableData: IncomeTaxAnnualList[] = AnnualEITList; //主表
	dateTime: Date = this.getTime(); //选择的时间
	showDailog: boolean = false; //展示表
	dialogWidth: number = window.screen.width < 1366 ? 1270 : 1320;
	// 初始化dateTime
	subsidiaryDate: any = [this.dateTime, this.dateTime];
	created() {
		this.changeDateTime();
	}
	getTime() {
		let year = new Date().getFullYear() - 1;
		let time = year + "01" + "01";
		return this.$utils.strToDate(time);
	}
	// 初始化dateTime
	changeDateTime() {
		this.subsidiaryDate = [this.dateTime, this.dateTime];
		// this.fetchData();
	}
	// 获取时间范围
	get disabledDate() {
		return {
			disabledDate: (time: Date) => {
				return (
					time.getFullYear() < new Date().getFullYear() - 4 ||
					time.getFullYear() > new Date().getFullYear() + 2
				);
			}
		};
	}
	mounted() {
		this.activeTab = "AnnualEITA100000";
		this.$store.dispatch("widthChange", window.screen.width);
	}

	// 选择时间
	changeDate(val: string) {
		this.curAccount.startPeriod = val;
		this.curAccount.endPeriod = val;
		this.fetchData();
	}
	// 获取数据
	fetchData() {
		let year = this.dateTime.getFullYear().toString();
		Vue.axios
			.get(
				`enterpriseincometaxannualtotal?accountBookId=${this.$store.state.accountBook.id}&year=${year}`
			)
			.then(res => {
				let list = res.data;
				for (var i = 1; i < this.tableData.length; i++) {
					this.tableData[i].isSelect = list[i - 1].isSelect;
					this.tableData[i].id = list[i - 1].id;
					this.tableData[i].year = list[i - 1].year;
					this.tableData[i].accountBookId = list[i - 1].accountBookId;
				}
			});
	}
	// 切换纳税申报表
	changeType(val: number) {
		if (val === 1) this.fetchData();
		else this.$router.push({ path: "/declaration" });
	}
	// 详情跳转各个页面
	annualData: any = null;
	changeUrl(row: IncomeTaxAnnualList) {
		this.annualData = row;
		this.showDailog = true;
	}
	// 关闭弹窗
	closeDialog() {
		this.annualData = null;
		this.showDailog = false;
	}
	// 修改填报选择
	changeCheck(row: IncomeTaxAnnualList) {
		Vue.axios.post(`enterpriseincometaxannualtotal`, row).then(res => {
			this.fetchData();
		});
	}
}
